package com.wintermar.inspection

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.ByteArray
import kotlin.Long
import kotlin.String
import migrations.AnswerChunkFileTable

public class AnswerChunkFileTableQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun <T : Any> getChunksByAnswerFileId(answerFileId: String, mapper: (
    id: String,
    answerFileId: String,
    fileName: String?,
    originalFileName: String?,
    chunkIndex: Long?,
    chunk: ByteArray?,
    fileSize: Long?,
    chunkSize: Long?,
    totalFiles: Long?,
  ) -> T): Query<T> = GetChunksByAnswerFileIdQuery(answerFileId) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2),
      cursor.getString(3),
      cursor.getLong(4),
      cursor.getBytes(5),
      cursor.getLong(6),
      cursor.getLong(7),
      cursor.getLong(8)
    )
  }

  public fun getChunksByAnswerFileId(answerFileId: String): Query<AnswerChunkFileTable> = getChunksByAnswerFileId(answerFileId, ::AnswerChunkFileTable)

  /**
   * @return The number of rows updated.
   */
  public fun insertChunk(
    id: String,
    answerFileId: String,
    fileName: String?,
    originalFileName: String?,
    chunkIndex: Long?,
    chunk: ByteArray?,
    fileSize: Long?,
    chunkSize: Long?,
    totalFiles: Long?,
  ): QueryResult<Long> {
    val result = driver.execute(-520_595_201, """
        |INSERT INTO AnswerChunkFileTable (id, answerFileId, fileName, originalFileName, chunkIndex, chunk, fileSize, chunkSize, totalFiles)
        |VALUES (?, ?, ?,?, ?, ?, ?, ?, ?)
        |ON CONFLICT(id) DO UPDATE SET
        |   answerFileId=excluded.answerFileId,
        |   fileName=excluded.fileName,
        |   originalFileName=excluded.originalFileName,
        |   chunkIndex=excluded.chunkIndex,
        |   chunk=excluded.chunk,
        |   fileSize=excluded.fileSize,
        |   chunkSize=excluded.chunkSize,
        |   totalFiles=excluded.totalFiles
        """.trimMargin(), 9) {
          var parameterIndex = 0
          bindString(parameterIndex++, id)
          bindString(parameterIndex++, answerFileId)
          bindString(parameterIndex++, fileName)
          bindString(parameterIndex++, originalFileName)
          bindLong(parameterIndex++, chunkIndex)
          bindBytes(parameterIndex++, chunk)
          bindLong(parameterIndex++, fileSize)
          bindLong(parameterIndex++, chunkSize)
          bindLong(parameterIndex++, totalFiles)
        }
    notifyQueries(-520_595_201) { emit ->
      emit("AnswerChunkFileTable")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public fun insertReplaceChunk(
    id: String,
    answerFileId: String,
    fileName: String?,
    originalFileName: String?,
    chunkIndex: Long?,
    chunk: ByteArray?,
    fileSize: Long?,
    chunkSize: Long?,
    totalFiles: Long?,
  ): QueryResult<Long> {
    val result = driver.execute(1_442_492_743, """
        |INSERT OR REPLACE INTO AnswerChunkFileTable (id, answerFileId, fileName, originalFileName, chunkIndex, chunk, fileSize, chunkSize, totalFiles)
        |VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 9) {
          var parameterIndex = 0
          bindString(parameterIndex++, id)
          bindString(parameterIndex++, answerFileId)
          bindString(parameterIndex++, fileName)
          bindString(parameterIndex++, originalFileName)
          bindLong(parameterIndex++, chunkIndex)
          bindBytes(parameterIndex++, chunk)
          bindLong(parameterIndex++, fileSize)
          bindLong(parameterIndex++, chunkSize)
          bindLong(parameterIndex++, totalFiles)
        }
    notifyQueries(1_442_492_743) { emit ->
      emit("AnswerChunkFileTable")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public fun deleteChunkById(id: String): QueryResult<Long> {
    val result = driver.execute(755_433_151, """DELETE FROM AnswerChunkFileTable WHERE id = ?""", 1) {
          var parameterIndex = 0
          bindString(parameterIndex++, id)
        }
    notifyQueries(755_433_151) { emit ->
      emit("AnswerChunkFileTable")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public fun deleteChunksByAnswerFileId(answerFileId: String): QueryResult<Long> {
    val result = driver.execute(-1_789_521_550, """DELETE FROM AnswerChunkFileTable WHERE answerFileId = ?""", 1) {
          var parameterIndex = 0
          bindString(parameterIndex++, answerFileId)
        }
    notifyQueries(-1_789_521_550) { emit ->
      emit("AnswerChunkFileTable")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public fun deleteAllChunks(): QueryResult<Long> {
    val result = driver.execute(2_121_736_071, """DELETE FROM AnswerChunkFileTable""", 0)
    notifyQueries(2_121_736_071) { emit ->
      emit("AnswerChunkFileTable")
    }
    return result
  }

  private inner class GetChunksByAnswerFileIdQuery<out T : Any>(
    public val answerFileId: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("AnswerChunkFileTable", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("AnswerChunkFileTable", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> = driver.executeQuery(-684_709_357, """SELECT AnswerChunkFileTable.id, AnswerChunkFileTable.answerFileId, AnswerChunkFileTable.fileName, AnswerChunkFileTable.originalFileName, AnswerChunkFileTable.chunkIndex, AnswerChunkFileTable.chunk, AnswerChunkFileTable.fileSize, AnswerChunkFileTable.chunkSize, AnswerChunkFileTable.totalFiles FROM AnswerChunkFileTable WHERE answerFileId = ? ORDER BY chunkIndex ASC""", mapper, 1) {
      var parameterIndex = 0
      bindString(parameterIndex++, answerFileId)
    }

    override fun toString(): String = "AnswerChunkFileTable.sq:getChunksByAnswerFileId"
  }
}
